import { c as _c } from "react/compiler-runtime";
import { lookup, Vehicle } from '@cruz-com/lookup';
import _ from 'lodash';
import { HiArrowDown, HiArrowRight, HiArrowUp, HiArrowUpRight, HiChevronDoubleDown } from 'react-icons/hi2';
export const EstimatedValue = t0 => {
  const $ = _c(20);
  const {
    d
  } = t0;
  if (_.isNull(d)) {
    return "-";
  }
  let t1;
  if ($[0] !== d) {
    t1 = _.find(lookup.vehicle.deal, {
      id: d
    }) || {};
    $[0] = d;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    id,
    name
  } = t1;
  if (!name) {
    return "-";
  }
  const t2 = `deal-s deal-s-${id}`;
  let t3;
  if ($[2] !== id) {
    t3 = id === Vehicle.DealEnum.Bad && <HiArrowDown className="size-4" aria-hidden="true" />;
    $[2] = id;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== id) {
    t4 = id === Vehicle.DealEnum.Fair && <HiArrowRight className="size-4" aria-hidden="true" />;
    $[4] = id;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== id) {
    t5 = id === Vehicle.DealEnum.Good && <HiArrowUpRight className="size-4" aria-hidden="true" />;
    $[6] = id;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== id) {
    t6 = id === Vehicle.DealEnum.Great && <HiArrowUp className="size-4" aria-hidden="true" />;
    $[8] = id;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== id) {
    t7 = id === Vehicle.DealEnum.Low && <HiChevronDoubleDown className="size-4" aria-hidden="true" />;
    $[10] = id;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== name || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t8 = <div className={t2}>{t3}{t4}{t5}{t6}{t7}{name}</div>;
    $[12] = name;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};